import React, { useEffect, useState, createContext, useContext } from 'react';
type Language = 'sk' | 'en' | 'ru' | 'ua';
type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
  getPath: (path: string) => string;
  navigate: (path: string) => void;
};
const translations = {
  sk: {
    // Navigation
    'nav.getStarted': 'Bezplatná konzultácia',
    'nav.home': 'Domov',
    'nav.services': 'Ceny',
    'nav.howItWorks': 'Ako to funguje',
    'nav.referral': 'Odporúčací program',
    'nav.privacy': 'Zásady ochrany osobných údajov',
    'nav.terms': 'Podmienky používania',
    'nav.pricing': 'Ceny',
    'nav.faq': 'Časté otázky',
    'nav.testimonials': 'Recenzie',
    // Cookie Banner
    'cookie.title': 'Používame súbory cookie',
    'cookie.description': 'Súbory cookie používame na zlepšenie vášho zážitku na našej stránke, analýzu návštevnosti a personalizáciu obsahu.',
    'cookie.accept': 'Prijať všetko',
    'cookie.decline': 'Odmietnuť',
    'cookie.learnMore': 'Zistiť viac',
    // Hero - H1 tag
    'hero.badge': 'Profesionálna webová agentúra',
    'hero.title': 'Vytvoríme pre vás webstránku na mieru',
    'hero.titleHighlight': 'len za 299 €',
    'hero.subtitle': 'Ukážeme vám bezplatný návrh vašej webstránky. Ak sa vám nebude páčiť — neplatíte nič.',
    'hero.bullet1': 'Bezplatný náhľad webstránky pred platbou',
    'hero.bullet2': '299 € — poplatok za vývoj webstránky, ak sa vám výsledok páči',
    'hero.bullet3': 'Pracujeme celosvetovo (plne online)',
    'hero.cta': 'Bezplatná konzultácia',
    'hero.referral': 'Odporúčací program',
    // Pricing - H2: Pricing & terms
    'pricing.title': 'Ceny',
    'pricing.titleHighlight': 'a podmienky',
    'pricing.subtitle': 'Najprv bezplatný návrh. Platba len vtedy, ak vám všetko vyhovuje.',
    // H3: Free website preview
    'pricing.demo.title': 'Bezplatný návrh webstránky',
    'pricing.demo.label': 'ZADARMO',
    'pricing.demo.desc': 'Ukážeme vám vašu budúcu webstránku pred platbou.',
    'pricing.demo.b1': 'Návrh prispôsobený vášmu podnikaniu',
    'pricing.demo.b2': 'Môžete požiadať o zmeny',
    'pricing.demo.b3': 'Nepáči sa vám to — neplatíte',
    'pricing.demo.cta': 'Bezplatná konzultácia',
    // H3: Website development (€299 one-time)
    'pricing.launch.title': 'Vývoj webstránky',
    'pricing.launch.price': '299 €',
    'pricing.launch.period': '(jednorazovo)',
    'pricing.launch.desc': 'Ak vám všetko vyhovuje — získate hotovú webstránku.',
    'pricing.launch.b1': 'Dizajn na mieru',
    'pricing.launch.b2': 'Prispôsobenie pre mobily',
    'pricing.launch.b3': 'Zmeny na požiadanie',
    'pricing.launch.b4': 'Kontaktný formulár',
    'pricing.launch.cta': 'Bezplatná konzultácia',
    // How It Works - H2
    'how.title': 'Ako to',
    'how.titleHighlight': 'funguje',
    // H3 steps
    'how.step1.title': 'Povedzte nám o svojom podnikaní',
    'how.step1.note': 'Zaberie to 2 minúty — čo robíte a akú webstránku potrebujete',
    'how.step2.title': 'Vytvoríme bezplatný náhľad webstránky',
    'how.step2.note': 'Ukážeme dizajn a štruktúru. Odkaz dostanete do 1–3 dní',
    'how.step3.title': 'Poviete nám, čo zmeniť',
    'how.step3.note': 'Text, sekcie, štýl — všetko upravíme',
    'how.step4.title': 'Keď ste spokojní, zaplatíte 299 €',
    'how.step4.note': 'Platba až po tom, čo poviete: "Áno, toto mi vyhovuje"',
    'how.step5.title': 'Pripojíme vašu doménu a zverejníme webstránku',
    'how.step5.note': 'Vaša webstránka bude spustená a začne prijímať dopyty',
    'how.note': 'Ak sa vám webstránka nepáči — neplatíte.',
    // FAQ - H2: Frequently Asked Questions
    'faq.title': 'Časté',
    'faq.titleHighlight': 'otázky',
    'faq.subtitle': 'Všetko, čo potrebujete vedieť o spolupráci s naším tímom',
    // H3 questions
    'faq.q1': 'Čo je to bezplatný návrh?',
    'faq.a1': 'Je to predbežná verzia vašej webstránky pred platbou.',
    'faq.q2': 'Kedy platím 299 €?',
    'faq.a2': 'Iba vtedy, ak vám návrh vyhovuje a chcete webstránku spustiť.',
    'faq.q3': 'Môžem požiadať o zmeny?',
    'faq.a3': 'Áno, pred spustením môžeme vykonať zmeny.',
    'faq.q4': 'Čo dostanem po zaplatení?',
    'faq.a4': 'Hotovú webstránku pre vaše podnikanie.',
    'faq.q5': 'Pracujete celosvetovo?',
    'faq.a5': 'Áno, pracujeme online s klientmi z rôznych krajín.',
    // Testimonials - H2: What clients say
    'testimonials.title': 'Recenzie',
    'testimonials.titleHighlight': 'klientov',
    'testimonials.subtitle': 'Čo hovoria klienti o spolupráci s nami',
    'testimonials.r1.name': 'Sarah',
    'testimonials.r1.text': 'Páčilo sa mi, že mi najprv ukázali webstránku zadarmo. Požiadala som o pár zmien, všetko rýchlo opravili. Zaplatila som, až keď bolo všetko perfektné.',
    'testimonials.r1.business': 'Kozmetička',
    'testimonials.r2.name': 'Alex',
    'testimonials.r2.text': 'Urobili mi prehľadnú webstránku pre moje služby. Najprv mi ukázali návrh, potom urobili zmeny. Zaplatil som až po schválení.',
    'testimonials.r2.business': 'Miestny údržbár',
    'testimonials.r3.name': 'James',
    'testimonials.r3.text': 'Je pohodlné, že nemusíte platiť vopred. Najprv som si pozrel webstránku, požiadal o zjednodušenie textu, potom som zaplatil. Všetko je férové a jasné.',
    'testimonials.r3.business': 'Psychológ',
    // Consultation - H2: Get your free preview
    'consultation.title': 'Objednajte si bezplatnú',
    'consultation.titleHighlight': 'konzultáciu',
    'consultation.subtitle': 'Povedzte nám, čo potrebujete — pošleme vám odkaz na náhľad.',
    'consultation.benefit1': 'Bezplatný náhľad',
    'consultation.benefit2': 'Rýchle dodanie',
    'consultation.benefit3': 'Bez záväzkov',
    'consultation.name': 'Meno',
    'consultation.namePlaceholder': 'Vaše meno',
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'vas@email.sk',
    'consultation.desc': 'Popis projektu',
    'consultation.descPlaceholder': 'Povedzte nám o svojom podnikaní a akú webstránku potrebujete...',
    'consultation.cta': 'Objednať bezplatnú konzultáciu',
    'consultation.note': 'Bez záväzkov. Ak sa vám webstránka nepáči — neplatíte.',
    'consultation.sending': 'Odosiela sa...',
    'consultation.or': 'alebo napíšte nášmu tímu priamo',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Služby',
    'footer.company': 'Spoločnosť',
    'footer.legal': 'Právne',
    'footer.contact': 'Kontakt',
    'footer.rights': 'Všetky práva vyhradené.',
    'footer.aboutLink': 'O spoločnosti',
    // Stats
    'stats.websites': 'Spustených webstránok',
    'stats.clients': 'Spokojných klientov',
    'stats.years': 'Rokov skúseností',
    'stats.title': 'Náš',
    'stats.titleHighlight': 'vplyv',
    'stats.subtitle': 'Prinášame výsledky pre firmy po celom svete',
    // AI Course Page
    'course.hero.badge': 'Staňte sa majiteľom digitálneho biznisu',
    'course.hero.title': 'Kúpte si IT biznis na kľúč: vlastné webové štúdio založené na AI',
    'course.hero.pill1': 'Bez skúseností',
    'course.hero.pill2': 'Rýchla návratnosť',
    'course.hero.pill3': 'Pracujte na seba',
    'course.hero.socialProof': 'študentov už zarába s AI',
    'course.hero.socialProofCount': '100+',
    'course.hero.specialPrice': 'Cena',
    'course.hero.buyCourse': 'Kúpiť biznis',
    'course.recognize.title': 'Spoznávate sa?',
    'course.recognize.c1.title': 'Pracujete pre iných — ale mohli by ste pre seba',
    'course.recognize.c1.text': 'Každý deň venujete svoj čas a energiu cudziemu biznisu. Ale svoj vlastný ste ešte nezačali.',
    'course.recognize.c2.title': 'Chcete viac peňazí — ale neviete ako',
    'course.recognize.c2.text': 'Váš plat nerastie. Freelancing sa zdá byť desivý. Máte pocit, že zarábanie online si vyžaduje špeciálne znalosti.',
    'course.recognize.c3.title': 'Myslíte si, že IT nie je pre vás',
    'course.recognize.c3.text': 'Kód, vývoj, technológie — znie to zložito. Máte pocit, že je to len pre tých, ktorí študovali roky.',
    'course.recognize.c4.title': 'Vidíte, ako iní zarábajú — a vy prichádzate o príležitosť',
    'course.recognize.c4.text': 'AI už zmenila trh. Tí, ktorí začali skoro, už zarábajú. Vy stále premýšľate.',
    'course.offer.title': 'Čo ponúkame?',
    'course.offer.tag1': 'Biznis na kľúč',
    'course.offer.tag2': 'Vhodné aj pre začiatočníkov',
    'course.offer.heading': 'Kúpiť it biznis na kľúč',
    'course.offer.description': 'Systém, ktorý vytvára webstránky za vás. Vy popíšete úlohu — AI navrhne štruktúru, nakreslí dizajn a napíše hotový kód.',
    'course.offer.tagline1': 'Jedno aktívum, ktoré otvára nový zdroj príjmu.',
    'course.offer.tagline2': 'Žiadne skúsenosti, žiadny kód — len vy a AI.',
    'course.offer.feature1': 'Webstránka IT agentúry',
    'course.offer.feature2': 'AI agent pre prototypovanie a dizajn',
    'course.offer.feature3': 'AI agent pre kódovanie a rozloženie',
    'course.offer.feature4': 'Sprievodca krok za krokom pre prácu so systémom',
    'course.offer.feature5': 'Doživotná technická podpora',
    'course.offer.price': '9 500 €',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Všetko, čo potrebujete, aby ste mohli začať vytvárať a predávať webstránky.',
    'course.offer.cta': 'Kúpiť biznis',
    'course.calc.title': 'Koľko môžete zarobiť vytváraním webstránok s AI?',
    'course.calc.priceLabel': 'Za koľko ste ochotní predať webstránku?',
    'course.calc.sitesLabel': 'Koľko webstránok mesačne chcete vytvoriť?',
    'course.calc.potentialIncome': 'VÁŠ POTENCIÁLNY PRÍJEM',
    'course.calc.perMonth': '/ mesiac',
    'course.calc.coursePrice': 'Cena biznisu',
    'course.calc.payback': 'Návratnosť',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Čistý zisk (1. mesiac)',
    'course.testimonials.title': 'Recenzie študentov',
    'course.testimonials.subtitle': 'Čo hovoria tí, ktorí už absolvovali školenie',
    'course.faq.title': 'Časté otázky',
    'course.faq.subtitle': 'Všetko, čo potrebujete vedieť o biznise na kľúč',
    'course.faq.q1': 'Potrebujem skúsenosti v IT alebo vývoji?',
    'course.faq.a1': 'Nie. Systém je plne automatizovaný — vy popíšete úlohu, AI urobí dizajn a kód. Žiadne programovanie, žiadna Figma.',
    'course.faq.q2': 'Čo presne dostanem po kúpe?',
    'course.faq.a2': 'Hotovú webstránku agentúry, dvoch AI agentov na tvorbu dizajnu a kódovanie, sprievodcu krok za krokom a doživotnú technickú podporu.',
    'course.faq.q3': 'Ako dlho trvá vytvorenie jednej webstránky?',
    'course.faq.a3': 'Od 30 minút do niekoľkých hodín v závislosti od zložitosti. AI urobí väčšinu práce — vy len skontrolujete výsledok.',
    'course.faq.q4': 'Môžem vidieť, ako systém funguje pred kúpou?',
    'course.faq.a4': 'Áno. Prihláste sa na bezplatnú konzultáciu — ukážeme vám demo a odpovieme na všetky otázky.',
    'course.faq.q5': 'Za koľko môžem predávať webstránky klientom?',
    'course.faq.a5': 'Toto je úplne na vašom rozhodnutí. Priemerná trhová hodnota jednostránkovej webstránky je 450 €. Z našej strany nie sú žiadne obmedzenia.',
    'course.faq.q6': 'Čo ak sa vyskytnú technické problémy?',
    'course.faq.a6': 'Poskytujeme doživotnú technickú podporu. Napíšte nám — pomôžeme vám vyriešiť akýkoľvek problém.',
    'course.faq.q7': 'Dá sa tento biznis škálovať?',
    'course.faq.a7': 'Áno. Systém nemá žiadne obmedzenia na počet webstránok. Čím viac objednávok — tým väčší príjem. Nie je potrebné najímať tím.',
    'course.fear.title1': 'Kým vy pochybujete — ',
    'course.fear.title2': 'niekto iný už začal svoj digitálny biznis.',
    'course.fear.f1.fear': '«Nikdy som nerobil webstránky»',
    'course.fear.f1.reality': 'Stačí popísať, čo chcete — AI urobí všetko za vás',
    'course.fear.f2.fear': '«Je to ťažké a trvá to dlho»',
    'course.fear.f2.reality': 'Svoju prvú webstránku vytvoríte hneď po prvom sedení',
    'course.fear.f3.fear': '«Neviem, kde nájsť klientov»',
    'course.fear.f3.reality': 'Každá reštaurácia, salón, lekár, obchod — je váš potenciálny klient',
    'course.fear.f4.fear': '«Čo ak zlyhám»',
    'course.fear.f4.reality': 'Mentor je nablízku — nenecháme vás, kým neuspejete',
    'course.cta.title': 'Ste pripravení začať svoj biznis?',
    'course.cta.subtitle': 'Jedno aktívum. Neobmedzené množstvo webstránok.',
    'course.cta.btn': 'Kúpiť biznis — 9 500 €',
    'course.cta.link': 'alebo si rezervujte bezplatnú konzultáciu →',
    'course.how.title': 'Ako to',
    'course.how.titleHighlight': 'funguje',
    'course.how.step1.title': 'Vy popíšete úlohu',
    'course.how.step1.note': 'Uveďte oblasť, štýl a čo by mala webstránka robiť — nič iné nie je potrebné',
    'course.how.step2.title': 'AI vytvorí dizajn',
    'course.how.step2.note': 'Agent vygeneruje moderný návrh pre vašu úlohu — bez Figmy a dizajnéra',
    'course.how.step3.title': 'AI nakóduje rozloženie',
    'course.how.step3.note': 'Druhý agent premení návrh na čistú fungujúcu webstránku — automaticky',
    'course.how.step4.title': 'Vy skontrolujete výsledok',
    'course.how.step4.note': 'Prezrite si webstránku, v prípade potreby urobte finálne úpravy',
    'course.how.step5.title': 'Odovzdáte klientovi — dostanete zaplatené',
    'course.how.step5.note': 'Klient dostane hotovú webstránku, vy — peniaze za prácu',
    'course.testimonials.label': 'Recenzie študentov',
    'course.testimonials.r1.name': 'Marina',
    'course.testimonials.r1.role': 'Freelancer, Kyjev',
    'course.testimonials.r1.text': 'Myslela som si, že je to ťažké. Postavila som svoju prvú stránku na jednom sedení a už som našla klienta. Mentor všetko jasne vysvetlil.',
    'course.testimonials.r2.name': 'Alexej',
    'course.testimonials.r2.role': 'Malý podnik, Varšava',
    'course.testimonials.r2.text': 'Chcel som robiť stránky pre svoj biznis. Po sedení som urobil stránku za jeden večer. Kurz sa mi hneď vrátil — ušetril som na vývojárovi.',
    'course.testimonials.r3.name': 'Dmitrij',
    'course.testimonials.r3.role': 'Bez IT skúseností, Berlín',
    'course.testimonials.r3.text': 'Nulové skúsenosti s programovaním. Po sedení som pochopil, ako to funguje a teraz robím stránky pre klientov. Stojí to za každý cent.',
    // Sale Page
    'sale.timer.title': 'Časovo obmedzená ponuka končí o:',
    'sale.timer.days': 'Dni',
    'sale.timer.hours': 'Hodiny',
    'sale.timer.minutes': 'Minúty',
    'sale.timer.seconds': 'Sekundy',
    'sale.hero.title': 'Vytvoríme pre vás webstránku na mieru',
    'sale.hero.titleHighlight': 'ZADARMO',
    'sale.hero.subtitle': 'Plaťte len 15 €/mesiac za hosting a podporu. Žiadne počiatočné náklady na vývoj.',
    'sale.hero.bullet1': 'Bezplatný vývoj webstránky',
    'sale.hero.bullet2': 'Iba 15 €/mesiac predplatné',
    'sale.hero.bullet3': 'Zrušiť môžete kedykoľvek',
    'sale.pricing.title': 'Cena vytvorenia webstránky',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Získajte svoju webstránku zadarmo, plaťte len malý mesačný poplatok.',
    'sale.pricing.launch.title': 'Používanie webstránky',
    'sale.pricing.launch.price': '15 €',
    'sale.pricing.launch.period': '/ mesiac',
    'sale.pricing.launch.desc': 'Všetko, čo potrebujete, aby vaša webstránka fungovala hladko.',
    // SMS Page
    'sms.timer.title': 'Časovo obmedzená ponuka končí o:',
    'sms.timer.days': 'Dni',
    'sms.timer.hours': 'Hodiny',
    'sms.timer.minutes': 'Minúty',
    'sms.timer.seconds': 'Sekundy',
    'sms.hero.title': 'Vytvoríme pre vás webstránku na mieru',
    'sms.hero.titleHighlight': 'ZADARMO',
    'sms.hero.subtitle': 'Plaťte len 15 €/mesiac za hosting a podporu. Žiadne počiatočné náklady na vývoj.',
    'sms.hero.bullet1': 'Bezplatný vývoj webstránky',
    'sms.hero.bullet2': 'Iba 15 €/mesiac predplatné',
    'sms.hero.bullet3': 'Zrušiť môžete kedykoľvek',
    'sms.pricing.title': 'Cena vytvorenia webstránky',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Získajte svoju webstránku zadarmo, plaťte len malý mesačný poplatok.',
    'sms.pricing.launch.title': 'Používanie webstránky',
    'sms.pricing.launch.price': '15 €',
    'sms.pricing.launch.period': '/ mesiac',
    'sms.pricing.launch.desc': 'Všetko, čo potrebujete, aby vaša webstránka fungovala hladko.',
    // About
    'about.team': 'Náš kreatívny tím',
    // Thank You Pages
    'thankyou.title': 'Ďakujeme!',
    'thankyou.desc': 'Vaša žiadosť bola prijatá. Do 24 hodín sa vám ozveme s bezplatným návrhom vašej webstránky.',
    'thankyou.ref.title': 'Vitajte v programe!',
    'thankyou.ref.desc': 'Vaša žiadosť o zapojenie do odporúčacieho programu bola prijatá.',
    'thankyou.ref.note': 'Do 24 hodín vás budeme kontaktovať s vaším jedinečným odporúčacím odkazom a všetkými detailmi, ktoré potrebujete, aby ste mohli začať zarábať 100 € za každé odporúčanie.',
    'thankyou.ref.next': 'Čo bude nasledovať?',
    'thankyou.ref.step1': 'Posúdime vašu žiadosť',
    'thankyou.ref.step2': 'Dostanete svoj jedinečný odporúčací odkaz',
    'thankyou.ref.step3': 'Zdieľajte odkaz a zarobte 100 € za každé úspešné odporúčanie',
    // Referral Page
    'ref.title': 'Odporúčací',
    'ref.titleHighlight': 'program',
    'ref.subtitle': 'Zarobte 100 € za každé úspešné odporúčanie',
    'ref.per': 'za úspešné odporúčanie',
    'ref.how': 'Ako to funguje',
    'ref.how.1.title': 'Odporučte nás',
    'ref.how.1.desc': 'Zdieľajte Jetly Agency s priateľmi, kolegami alebo vo vašej sieti, ktorí potrebujú webstránku.',
    'ref.how.2.title': 'Dostanú demo',
    'ref.how.2.desc': 'Váš kontakt dostane bezplatné demo webstránky. Ak zaplatia 299 €, vy zarábate.',
    'ref.how.3.title': 'Zarobíte 100 €',
    'ref.how.3.desc': 'Získajte 100 € vyplatených priamo vám do 7 dní po úspešnej platbe.',
    'ref.why': 'Prečo sa pridať?',
    'ref.why.1': '100 € za odporúčanie',
    'ref.why.2': 'Žiadne limity na zárobky',
    'ref.why.3': 'Ľahko sa predáva (bezplatné demo)',
    'ref.why.4': 'Rýchle výplaty (7 dní)',
    'ref.form.title': 'Pridajte sa do programu',
    'ref.form.desc': 'Vyplňte formulár nižšie a my vás budeme kontaktovať s vaším jedinečným odporúčacím odkazom.',
    'ref.form.name': 'Vaše meno *',
    'ref.form.namePlaceholder': 'Jozef Mrkvička',
    'ref.form.email': 'E-mailová adresa *',
    'ref.form.emailPlaceholder': 'jozef@priklad.sk',
    'ref.form.phone': 'Telefón *',
    'ref.form.phonePlaceholder': '+421 900 000 000',
    'ref.form.message': 'Povedzte nám o vašej sieti',
    'ref.form.messagePlaceholder': 'Koho plánujete odporučiť? (napr. majitelia malých podnikov, podnikatelia atď.)',
    'ref.form.submit': 'Pridať sa do programu',
    'ref.form.submitting': 'Odosiela sa...'
  },
  en: {
    // Navigation
    'nav.getStarted': 'Free consultation',
    'nav.home': 'Home',
    'nav.services': 'Pricing',
    'nav.howItWorks': 'How it works',
    'nav.referral': 'Referral Program',
    'nav.privacy': 'Privacy Policy',
    'nav.terms': 'Terms of Service',
    'nav.pricing': 'Pricing',
    'nav.faq': 'FAQ',
    'nav.testimonials': 'Reviews',
    // Cookie Banner
    'cookie.title': 'We use cookies',
    'cookie.description': 'We use cookies to improve your experience on our site, analyze traffic, and personalize content.',
    'cookie.accept': 'Accept All',
    'cookie.decline': 'Decline',
    'cookie.learnMore': 'Learn More',
    // Hero - H1 tag
    'hero.badge': 'Professional web agency',
    'hero.title': "We'll create a custom website for you",
    'hero.titleHighlight': 'for just €299',
    'hero.subtitle': "We'll show you a free mockup of your website. If you don't like it — you pay nothing.",
    'hero.bullet1': 'Free website preview before payment',
    'hero.bullet2': '€299 — website development fee if you like the result',
    'hero.bullet3': 'We work worldwide (fully remote)',
    'hero.cta': 'Free consultation',
    'hero.referral': 'Referral Program',
    // Pricing - H2: Pricing & terms
    'pricing.title': 'Pricing',
    'pricing.titleHighlight': '& terms',
    'pricing.subtitle': 'First a free mockup. Payment only if everything suits you.',
    // H3: Free website preview
    'pricing.demo.title': 'Free website mockup',
    'pricing.demo.label': 'FREE',
    'pricing.demo.desc': "We'll show you your future website before payment.",
    'pricing.demo.b1': 'Mockup tailored to your business',
    'pricing.demo.b2': 'You can request changes',
    'pricing.demo.b3': "Don't like it — don't pay",
    'pricing.demo.cta': 'Free consultation',
    // H3: Website development (€299 one-time)
    'pricing.launch.title': 'Website development',
    'pricing.launch.price': '€299',
    'pricing.launch.period': '(one-time)',
    'pricing.launch.desc': 'If everything suits you — you get a ready-to-use website.',
    'pricing.launch.b1': 'Custom design',
    'pricing.launch.b2': 'Mobile adaptation',
    'pricing.launch.b3': 'Changes on request',
    'pricing.launch.b4': 'Lead form',
    'pricing.launch.cta': 'Free consultation',
    // How It Works - H2
    'how.title': 'How it',
    'how.titleHighlight': 'works',
    // H3 steps
    'how.step1.title': 'Tell us about your business',
    'how.step1.note': 'Takes 2 minutes — what you do and what website you need',
    'how.step2.title': 'We create a free website preview',
    'how.step2.note': 'We show the design and structure. You get a link in 1–3 days',
    'how.step3.title': 'You tell us what to change',
    'how.step3.note': 'Text, sections, style — we update everything',
    'how.step4.title': "When you're happy with it, you pay €299",
    'how.step4.note': 'Payment only after you say: "Yes, this works for me"',
    'how.step5.title': 'We connect your domain and publish the website',
    'how.step5.note': 'Your website goes live and starts collecting inquiries',
    'how.note': "If you don't like the website — you don't pay.",
    // FAQ - H2: Frequently Asked Questions
    'faq.title': 'Frequently Asked',
    'faq.titleHighlight': 'Questions',
    'faq.subtitle': 'Everything you need to know about working with our team',
    // H3 questions
    'faq.q1': 'What is a free mockup?',
    'faq.a1': "It's a preliminary version of your website before payment.",
    'faq.q2': 'When do I pay €299?',
    'faq.a2': 'Only if the mockup suits you and you want to launch the website.',
    'faq.q3': 'Can I request changes?',
    'faq.a3': 'Yes, we can make changes before launch.',
    'faq.q4': 'What do I get after payment?',
    'faq.a4': 'A ready-to-use website for your business.',
    'faq.q5': 'Do you work worldwide?',
    'faq.a5': 'Yes, we work online with clients from different countries.',
    // Testimonials - H2: What clients say
    'testimonials.title': 'Client',
    'testimonials.titleHighlight': 'Reviews',
    'testimonials.subtitle': 'What clients say about working with us',
    'testimonials.r1.name': 'Sarah',
    'testimonials.r1.text': 'I liked that they showed me the website for free first. I asked for a couple of changes, everything was fixed quickly. I paid only when everything was perfect.',
    'testimonials.r1.business': 'Beauty specialist',
    'testimonials.r2.name': 'Alex',
    'testimonials.r2.text': 'They made a clear website for my services. First they showed me the mockup, then made changes. I paid only after confirmation.',
    'testimonials.r2.business': 'Local handyman',
    'testimonials.r3.name': 'James',
    'testimonials.r3.text': "It's convenient that you don't have to pay upfront. First I looked at the website, asked to simplify the text, then paid. Everything is fair and clear.",
    'testimonials.r3.business': 'Psychologist',
    // Consultation - H2: Get your free preview
    'consultation.title': 'Order a free',
    'consultation.titleHighlight': 'consultation',
    'consultation.subtitle': "Tell us what you need — we'll send a preview link.",
    'consultation.benefit1': 'Free preview',
    'consultation.benefit2': 'Fast delivery',
    'consultation.benefit3': 'No commitment',
    'consultation.name': 'Name',
    'consultation.namePlaceholder': 'Your name',
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'your@email.com',
    'consultation.desc': 'Project description',
    'consultation.descPlaceholder': 'Tell us about your business and what kind of website you need...',
    'consultation.cta': 'Order a free consultation',
    'consultation.note': "No commitment. If you don't like the website — you don't pay.",
    'consultation.sending': 'Sending...',
    'consultation.or': 'or talk to our team directly',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Services',
    'footer.company': 'Company',
    'footer.legal': 'Legal',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'footer.aboutLink': 'About Jetly',
    // Stats
    'stats.websites': 'Websites Launched',
    'stats.clients': 'Happy Clients',
    'stats.years': 'Years Experience',
    'stats.title': 'Our',
    'stats.titleHighlight': 'Impact',
    'stats.subtitle': 'Delivering results for businesses worldwide',
    // AI Course Page
    'course.hero.badge': 'Become a digital business owner',
    'course.hero.title': 'Buy a turnkey IT business: your own AI-based web studio',
    'course.hero.pill1': 'No experience needed',
    'course.hero.pill2': 'Quick ROI',
    'course.hero.pill3': 'Work for yourself',
    'course.hero.socialProof': 'students already earning with AI',
    'course.hero.socialProofCount': '100+',
    'course.hero.specialPrice': 'Price',
    'course.hero.buyCourse': 'Buy business',
    'course.recognize.title': 'Do you recognize yourself?',
    'course.recognize.c1.title': 'Working for someone else — but could work for yourself',
    'course.recognize.c1.text': "Every day you give your time and energy to someone else's business. But you still haven't started your own.",
    'course.recognize.c2.title': "Want more money — but don't know how",
    'course.recognize.c2.text': "Your salary isn't growing. Freelancing seems scary. It feels like making money online requires special knowledge.",
    'course.recognize.c3.title': "Think IT isn't for you",
    'course.recognize.c3.text': "Code, development, technology — sounds complicated. Feels like it's only for those who studied for years.",
    'course.recognize.c4.title': 'See others earning — and missing out',
    'course.recognize.c4.text': "AI has already changed the market. Those who got in early are already earning. You're still thinking.",
    'course.offer.title': 'What we offer?',
    'course.offer.tag1': 'Turnkey business',
    'course.offer.tag2': 'Suitable even for beginners',
    'course.offer.heading': 'Купить it бизнес под ключ',
    'course.offer.description': 'A system that creates websites for you. You describe the task — AI prototypes the structure, draws the design, and writes the ready code.',
    'course.offer.tagline1': 'One asset that opens a new source of income.',
    'course.offer.tagline2': 'No experience, no code — just you and AI.',
    'course.offer.feature1': 'IT agency website',
    'course.offer.feature2': 'AI agent for prototyping and design',
    'course.offer.feature3': 'AI agent for coding and layout',
    'course.offer.feature4': 'Step-by-step guide on working with the system',
    'course.offer.feature5': 'Lifetime technical support',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Everything you need to start creating and selling websites.',
    'course.offer.cta': 'Buy business',
    'course.calc.title': 'How much can you earn creating websites with AI?',
    'course.calc.priceLabel': 'How much are you willing to sell a website for?',
    'course.calc.sitesLabel': 'How many websites per month do you want to make?',
    'course.calc.potentialIncome': 'YOUR POTENTIAL INCOME',
    'course.calc.perMonth': '/ month',
    'course.calc.coursePrice': 'Business price',
    'course.calc.payback': 'Payback',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Net profit (1st month)',
    'course.testimonials.title': 'Student reviews',
    'course.testimonials.subtitle': 'What those who have already completed the session say',
    'course.faq.title': 'Frequently asked questions',
    'course.faq.subtitle': 'Everything you need to know about the turnkey business',
    'course.faq.q1': 'Do I need experience in IT or development?',
    'course.faq.a1': 'No. The system is fully automated — you describe the task, AI does the design and code. No programming, no Figma.',
    'course.faq.q2': 'What exactly do I get after purchase?',
    'course.faq.a2': 'A ready-made agency website, two AI agents for creating design and coding, a step-by-step guide on working with the system, and lifetime technical support.',
    'course.faq.q3': 'How long does it take to create one website?',
    'course.faq.a3': 'From 30 minutes to several hours depending on complexity. AI does most of the work — you only need to check the result.',
    'course.faq.q4': 'Can I see how the system works before buying?',
    'course.faq.a4': 'Yes. Sign up for a free consultation — we will show a demo and answer all questions.',
    'course.faq.q5': 'How much can I sell websites to clients for?',
    'course.faq.a5': 'This is entirely your decision. The average market value of a single-page website is €450. There are no restrictions on our part.',
    'course.faq.q6': 'What if technical problems arise?',
    'course.faq.a6': 'We provide lifetime technical support. Write to us — we will help you figure out any issue.',
    'course.faq.q7': 'Can this business be scaled?',
    'course.faq.a7': 'Yes. The system has no limits on the number of websites. The more orders — the more income. No need to hire a team.',
    'course.fear.title1': "While you're doubting — ",
    'course.fear.title2': 'someone has already started their digital business.',
    'course.fear.f1.fear': "«I've never built websites»",
    'course.fear.f1.reality': 'Just describe what you want — AI will do everything itself',
    'course.fear.f2.fear': "«It's hard and takes a long time»",
    'course.fear.f2.reality': 'You will create your first website right after the first session',
    'course.fear.f3.fear': "«I don't know where to find clients»",
    'course.fear.f3.reality': 'Every restaurant, salon, doctor, shop — is your potential client',
    'course.fear.f4.fear': '«What if I fail»',
    'course.fear.f4.reality': "The mentor is nearby — we won't leave you until you succeed",
    'course.cta.title': 'Ready to start your business?',
    'course.cta.subtitle': 'One asset. Unlimited websites.',
    'course.cta.btn': 'Buy the business — €9 500',
    'course.cta.link': 'or book a free consultation →',
    'course.how.title': 'How it',
    'course.how.titleHighlight': 'works',
    'course.how.step1.title': 'You describe the task',
    'course.how.step1.note': 'Specify the niche, style, and what the site should do — nothing else is needed',
    'course.how.step2.title': 'AI creates the design',
    'course.how.step2.note': 'The agent generates a modern layout for your task — without Figma and a designer',
    'course.how.step3.title': 'AI codes the layout',
    'course.how.step3.note': 'The second agent turns the layout into a clean working website — automatically',
    'course.how.step4.title': 'You check the result',
    'course.how.step4.note': 'Review the site, make final edits if necessary',
    'course.how.step5.title': 'Deliver to the client — get paid',
    'course.how.step5.note': 'The client gets a ready website, you — money for the work',
    'course.testimonials.label': 'Student Reviews',
    'course.testimonials.r1.name': 'Marina',
    'course.testimonials.r1.role': 'Freelancer, Kyiv',
    'course.testimonials.r1.text': 'I thought it was hard. Built my first site in one session and already found a client. The mentor explained everything clearly, no fluff.',
    'course.testimonials.r2.name': 'Alexey',
    'course.testimonials.r2.role': 'Small Business, Warsaw',
    'course.testimonials.r2.text': 'Wanted to build sites for my business. After the session, I made a site in one evening. Paid off the course immediately — saved on a developer.',
    'course.testimonials.r3.name': 'Dmitry',
    'course.testimonials.r3.role': 'No IT experience, Berlin',
    'course.testimonials.r3.text': 'Zero programming experience. After the session, I understood how it works and now build sites for clients. Worth every cent.',
    // Sale Page
    'sale.timer.title': 'Limited time offer ends in:',
    'sale.timer.days': 'Days',
    'sale.timer.hours': 'Hours',
    'sale.timer.minutes': 'Minutes',
    'sale.timer.seconds': 'Seconds',
    'sale.hero.title': "We'll create a custom website for you",
    'sale.hero.titleHighlight': 'for FREE',
    'sale.hero.subtitle': 'Pay only €15/month for hosting and support. No upfront development costs.',
    'sale.hero.bullet1': 'Free website development',
    'sale.hero.bullet2': 'Only €15/month subscription',
    'sale.hero.bullet3': 'Cancel anytime',
    'sale.pricing.title': 'Cost of website creation',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Get your website built for free, just pay a small monthly fee.',
    'sale.pricing.launch.title': 'Website Usage',
    'sale.pricing.launch.price': '€15',
    'sale.pricing.launch.period': '/ month',
    'sale.pricing.launch.desc': 'Everything you need to keep your website running smoothly.',
    // SMS Page
    'sms.timer.title': 'Limited time offer ends in:',
    'sms.timer.days': 'Days',
    'sms.timer.hours': 'Hours',
    'sms.timer.minutes': 'Minutes',
    'sms.timer.seconds': 'Seconds',
    'sms.hero.title': "We'll create a custom website for you",
    'sms.hero.titleHighlight': 'for FREE',
    'sms.hero.subtitle': 'Pay only 650 ₴/month for hosting and support. No upfront development costs.',
    'sms.hero.bullet1': 'Free website development',
    'sms.hero.bullet2': 'Only 650 ₴/month subscription',
    'sms.hero.bullet3': 'Cancel anytime',
    'sms.pricing.title': 'Cost of website creation',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Get your website built for free, just pay a small monthly fee.',
    'sms.pricing.launch.title': 'Website Usage',
    'sms.pricing.launch.price': '650 ₴',
    'sms.pricing.launch.period': '/ month',
    'sms.pricing.launch.desc': 'Everything you need to keep your website running smoothly.',
    // About
    'about.team': 'Our Creative Team',
    // Thank You Pages
    'thankyou.title': 'Thank you!',
    'thankyou.desc': "Your request has been received. We'll get back to you within 24 hours with your free website preview.",
    'thankyou.ref.title': 'Welcome to the Program!',
    'thankyou.ref.desc': 'Your referral application has been received.',
    'thankyou.ref.note': "We'll contact you within 24 hours with your unique referral link and all the details you need to start earning €100 per referral.",
    'thankyou.ref.next': 'What happens next?',
    'thankyou.ref.step1': "We'll review your application",
    'thankyou.ref.step2': "You'll receive your unique referral link",
    'thankyou.ref.step3': 'Share the link and earn €100 for each successful referral',
    // Referral Page
    'ref.title': 'Referral',
    'ref.titleHighlight': 'Program',
    'ref.subtitle': 'Earn €100 for every successful referral',
    'ref.per': 'per successful referral',
    'ref.how': 'How It Works',
    'ref.how.1.title': 'Recommend Us',
    'ref.how.1.desc': 'Share Jetly Agency with friends, colleagues, or your network who need a website.',
    'ref.how.2.title': 'They Get Demo',
    'ref.how.2.desc': 'Your referral receives a free website demo. If they pay €299, you earn.',
    'ref.how.3.title': 'You Earn €100',
    'ref.how.3.desc': 'Receive €100 paid directly to you within 7 days after successful payment.',
    'ref.why': 'Why Join?',
    'ref.why.1': '€100 per referral',
    'ref.why.2': 'No limits on earnings',
    'ref.why.3': 'Easy to sell (free demo)',
    'ref.why.4': 'Fast payouts (7 days)',
    'ref.form.title': 'Join Referral Program',
    'ref.form.desc': "Fill out the form below and we'll contact you with your unique referral link.",
    'ref.form.name': 'Your Name *',
    'ref.form.namePlaceholder': 'John Doe',
    'ref.form.email': 'Email Address *',
    'ref.form.emailPlaceholder': 'john@example.com',
    'ref.form.phone': 'Phone *',
    'ref.form.phonePlaceholder': '+1 234 567 8900',
    'ref.form.message': 'Tell Us About Your Network',
    'ref.form.messagePlaceholder': 'Who do you plan to refer? (e.g., small business owners, entrepreneurs, etc.)',
    'ref.form.submit': 'Join Program',
    'ref.form.submitting': 'Submitting...'
  },
  ru: {
    // Navigation
    'nav.getStarted': 'Бесплатная консультация',
    'nav.home': 'Главная',
    'nav.services': 'Цены',
    'nav.howItWorks': 'Как это работает',
    'nav.referral': 'Реферальная программа',
    'nav.privacy': 'Политика конфиденциальности',
    'nav.terms': 'Условия использования',
    'nav.pricing': 'Цены',
    'nav.faq': 'Вопросы',
    'nav.testimonials': 'Отзывы',
    // Cookie Banner
    'cookie.title': 'Мы используем cookies',
    'cookie.description': 'Мы используем cookies для улучшения вашего опыта на сайте, анализа трафика и персонализации контента.',
    'cookie.accept': 'Принять все',
    'cookie.decline': 'Отклонить',
    'cookie.learnMore': 'Подробнее',
    // Hero - H1
    'hero.badge': 'Профессиональное веб-агентство',
    'hero.title': 'Сделаем индивидуальный сайт для вас',
    'hero.titleHighlight': 'всего за €299',
    'hero.subtitle': 'Покажем бесплатный макет вашего сайта. Если не понравится — вы ничего не платите.',
    'hero.bullet1': 'Бесплатное превью сайта до оплаты',
    'hero.bullet2': '€299 — стоимость разработки сайта, если вам всё подходит',
    'hero.bullet3': 'Работаем онлайн по всему миру',
    'hero.cta': 'Бесплатная консультация',
    'hero.referral': 'Реферальная программа',
    // Pricing - H2: Цены и условия
    'pricing.title': 'Цены',
    'pricing.titleHighlight': 'и условия',
    'pricing.subtitle': 'Сначала бесплатный макет. Оплата только если вам всё подходит.',
    // H3: Бесплатное демо сайта
    'pricing.demo.title': 'Бесплатный макет сайта',
    'pricing.demo.label': 'БЕСПЛАТНО',
    'pricing.demo.desc': 'Покажем ваш будущий сайт до оплаты.',
    'pricing.demo.b1': 'Макет под ваш бизнес',
    'pricing.demo.b2': 'Можно попросить правки',
    'pricing.demo.b3': 'Если не понравится — не платите',
    'pricing.demo.cta': 'Бесплатная консультация',
    // H3: Разработка сайта — €299 (разово)
    'pricing.launch.title': 'Разработка сайта',
    'pricing.launch.price': '€299',
    'pricing.launch.period': '(единоразово)',
    'pricing.launch.desc': 'Если вам всё подходит — вы получаете готовый сайт.',
    'pricing.launch.b1': 'Индивидуальный дизайн',
    'pricing.launch.b2': 'Адаптация под телефон',
    'pricing.launch.b3': 'Правки по запросу',
    'pricing.launch.b4': 'Форма заявок',
    'pricing.launch.cta': 'Бесплатная консультация',
    // How It Works - H2: Как это работает
    'how.title': 'Как это',
    'how.titleHighlight': 'работает',
    // H3 steps
    'how.step1.title': 'Расскажите о вашем бизнесе',
    'how.step1.note': 'Займёт 2 минуты — чем занимаетесь и какой сайт нужен',
    'how.step2.title': 'Мы делаем бесплатное демо сайта',
    'how.step2.note': 'Покажем дизайн и структуру. Пришлём ссылку в 1–3 дня',
    'how.step3.title': 'Вы говорите, что изменить',
    'how.step3.note': 'Текст, блоки, стиль — мы всё правим под вас',
    'how.step4.title': 'Если всё подходит — вы оплачиваете €299',
    'how.step4.note': 'Оплата только после того, как вы скажете: "Да, мне подходит"',
    'how.step5.title': 'Подключаем домен и публикуем сайт',
    'how.step5.note': 'Сайт начинает работать и принимать заявки',
    'how.note': 'Если сайт вам не понравится — вы не платите.',
    // FAQ - H2: Частые вопросы
    'faq.title': 'Частые',
    'faq.titleHighlight': 'вопросы',
    'faq.subtitle': 'Всё, что нужно знать о работе с нами',
    // H3 questions
    'faq.q1': 'Что такое бесплатный макет?',
    'faq.a1': 'Это предварительный вариант вашего сайта до оплаты.',
    'faq.q2': 'Когда я плачу €299?',
    'faq.a2': 'Только если макет вам подходит и вы хотите запускать сайт.',
    'faq.q3': 'Можно ли попросить правки?',
    'faq.a3': 'Да, мы можем внести изменения перед запуском.',
    'faq.q4': 'Что я получаю после оплаты?',
    'faq.a4': 'Готовый сайт для вашего бизнеса.',
    'faq.q5': 'Вы работаете по всему миру?',
    'faq.a5': 'Да, работаем онлайн с клиентами из разных стран.',
    // Testimonials - H2: Отзывы клиентов
    'testimonials.title': 'Отзывы',
    'testimonials.titleHighlight': 'клиентов',
    'testimonials.subtitle': 'Что говорят клиенты о работе с нами',
    'testimonials.r1.name': 'Анастасия',
    'testimonials.r1.text': 'Понравилось, что сначала мне показали сайт бесплатно. Я попросила пару правок, всё быстро исправили. Оплатила только когда всё устроило.',
    'testimonials.r1.business': 'Мастер бровей',
    'testimonials.r2.name': 'Дмитрий',
    'testimonials.r2.text': 'Мне сделали понятный сайт под мои услуги. Сначала показали макет, потом внесли правки. Оплатил только после подтверждения.',
    'testimonials.r2.business': 'Мастер по сантехнике',
    'testimonials.r3.name': 'Сергей',
    'testimonials.r3.text': 'Удобно, что не нужно платить заранее. Сначала посмотрел сайт, попросил упростить текст, после этого оплатил. Всё честно и понятно.',
    'testimonials.r3.business': 'Психолог',
    // Consultation - H2: Получить бесплатное демо
    'consultation.title': 'Заказать бесплатную',
    'consultation.titleHighlight': 'консультацию',
    'consultation.subtitle': 'Расскажите, что вам нужно — мы пришлём ссылку на превью.',
    'consultation.benefit1': 'Бесплатный просмотр',
    'consultation.benefit2': 'Быстрая доставка',
    'consultation.benefit3': 'Без обязательств',
    'consultation.name': 'Имя',
    'consultation.namePlaceholder': 'Ваше имя',
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'ваш@email.com',
    'consultation.desc': 'Описание проекта',
    'consultation.descPlaceholder': 'Расскажите о вашем бизнесе и о том, какой сайт вам нужен…',
    'consultation.cta': 'Заказать бесплатную консультацию',
    'consultation.note': 'Без обязательств. Если сайт не понравится — вы не платите.',
    'consultation.sending': 'Отправка...',
    'consultation.or': 'или напишите нам напрямую',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Услуги',
    'footer.company': 'Компания',
    'footer.legal': 'Юридическое',
    'footer.contact': 'Контакты',
    'footer.rights': 'Все права защищены.',
    'footer.aboutLink': 'О компании',
    // Stats
    'stats.websites': 'Сайтов запущено',
    'stats.clients': 'Довольных клиентов',
    'stats.years': 'Лет опыта',
    'stats.title': 'Наш',
    'stats.titleHighlight': 'Вклад',
    'stats.subtitle': 'Результаты для бизнеса по всему миру',
    // AI Course Page
    'course.hero.badge': 'Стань владельцем digital-бизнеса',
    'course.hero.title': 'Купить готовый IT-бизнес под ключ: собственная веб-студия на базе ИИ',
    'course.hero.pill1': 'Без опыта',
    'course.hero.pill2': 'Быстро окупается',
    'course.hero.pill3': 'Работай на себя',
    'course.hero.socialProof': 'уже зарабатывают с ИИ',
    'course.hero.socialProofCount': '100+ студентов',
    'course.hero.specialPrice': 'Стоимость',
    'course.hero.buyCourse': 'Купить бизнес',
    'course.recognize.title': 'Узнаёшь себя?',
    'course.recognize.c1.title': 'Работаешь на кого-то — а мог бы на себя',
    'course.recognize.c1.text': 'Каждый день отдаёшь своё время и силы чужому бизнесу. А свой — всё никак не начать.',
    'course.recognize.c2.title': 'Хочешь больше денег — но не знаешь как',
    'course.recognize.c2.text': 'Зарплата не растёт. Фриланс пугает. Кажется что для заработка в интернете нужны особые знания.',
    'course.recognize.c3.title': 'Думаешь что IT — это не для тебя',
    'course.recognize.c3.text': 'Код, разработка, технологии — звучит сложно. Кажется что это только для тех кто учился годами.',
    'course.recognize.c4.title': 'Видишь как другие зарабатывают — и упускаешь время',
    'course.recognize.c4.text': 'ИИ уже изменил рынок. Те кто зашёл раньше — уже зарабатывают. Ты всё ещё думаешь.',
    'course.offer.title': 'Что мы предлагаем?',
    'course.offer.tag1': 'Готовый бизнес',
    'course.offer.tag2': 'Подходит даже для новичков',
    'course.offer.heading': 'Купить it бизнес под ключ',
    'course.offer.description': 'Система, которая создает сайты вместо тебя. Ты описываешь задачу — ИИ сам прототипирует структуру, рисует дизайн и верстает готовый код.',
    'course.offer.tagline1': 'Один актив, который открывает новый источник дохода.',
    'course.offer.tagline2': 'Без опыта, без кода — просто ты и ИИ.',
    'course.offer.feature1': 'Сайт IT агентства',
    'course.offer.feature2': 'ИИ-агент прототипирования и дизайна',
    'course.offer.feature3': 'ИИ-агент верстки и написания кода',
    'course.offer.feature4': 'Пошаговый гайд по работе с системой',
    'course.offer.feature5': 'Пожизненная техническая поддержка',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Всё, что нужно, чтобы начать создавать и продавать сайты.',
    'course.offer.cta': 'Купить бизнес',
    'course.calc.title': 'Сколько можно заработать на создании сайтов с помощью ИИ?',
    'course.calc.priceLabel': 'За сколько ты готов продать сайт?',
    'course.calc.sitesLabel': 'Сколько сайтов в месяц ты хочешь делать?',
    'course.calc.potentialIncome': 'ТВОЙ ПОТЕНЦИАЛЬНЫЙ ДОХОД',
    'course.calc.perMonth': '/ мес',
    'course.calc.coursePrice': 'Стоимость бизнеса',
    'course.calc.payback': 'Окупаемость',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Чистая прибыль (1-й мес)',
    'course.faq.title': 'Частые вопросы',
    'course.faq.subtitle': 'Всё, что нужно знать о готовом бизнесе',
    'course.faq.q1': 'Нужен ли опыт в IT или разработке?',
    'course.faq.a1': 'Нет. Система полностью автоматизирована — ты описываешь задачу, ИИ делает дизайн и код. Никакого программирования, никакого Figma.',
    'course.faq.q2': 'Что конкретно я получаю после покупки?',
    'course.faq.a2': 'Готовый сайт агентства, два ИИ-агента для создания дизайна и верстки кода, пошаговый гайд по работе с системой и пожизненную техническую поддержку.',
    'course.faq.q3': 'Сколько времени занимает создание одного сайта?',
    'course.faq.a3': 'От 30 минут до нескольких часов в зависимости от сложности. Большую часть работы выполняет ИИ — тебе остается только проверить результат.',
    'course.faq.q4': 'Можно ли увидеть как работает система до покупки?',
    'course.faq.a4': 'Да. Запишись на бесплатную консультацию — мы покажем демо и ответим на все вопросы.',
    'course.faq.q5': 'За сколько я могу продавать сайты клиентам?',
    'course.faq.a5': 'Это полностью твое решение. Средняя рыночная стоимость одностраничного сайта — €450. Никаких ограничений с нашей стороны нет.',
    'course.faq.q6': 'Что если возникнут технические проблемы?',
    'course.faq.a6': 'Мы предоставляем пожизненную техническую поддержку. Напишешь нам — поможем разобраться с любым вопросом.',
    'course.faq.q7': 'Можно ли масштабировать этот бизнес?',
    'course.faq.a7': 'Да. Система не имеет ограничений по количеству сайтов. Чем больше заказов — тем больше доход. Нанимать команду не нужно.',
    'course.fear.title1': 'Пока ты сомневаешься — ',
    'course.fear.title2': 'кто-то уже открыл свой digital-бизнес.',
    'course.fear.f1.fear': '«Я никогда не делал сайты»',
    'course.fear.f1.reality': 'Просто опиши что хочешь — ИИ сделает всё сам',
    'course.fear.f2.fear': '«Это сложно и долго»',
    'course.fear.f2.reality': 'Ты создашь первый сайт прямо после первого занятия',
    'course.fear.f3.fear': '«Не знаю где брать клиентов»',
    'course.fear.f3.reality': 'Каждый ресторан, салон, врач, магазин — твой потенциальный клиент',
    'course.fear.f4.fear': '«А вдруг не получится»',
    'course.fear.f4.reality': 'Ментор рядом — не бросим пока не получится',
    'course.cta.title': 'Готовы начать бизнес?',
    'course.cta.subtitle': 'Один актив. Неограниченное количество сайтов.',
    'course.cta.btn': 'Купить бизнес — €9 500',
    'course.cta.link': 'или записаться на бесплатную консультацию →',
    'course.how.title': 'Как это',
    'course.how.titleHighlight': 'работает',
    'course.how.step1.title': 'Ты описываешь задачу',
    'course.how.step1.note': 'Указываешь нишу, стиль и что должен делать сайт — больше ничего не нужно',
    'course.how.step2.title': 'ИИ создает дизайн',
    'course.how.step2.note': 'Агент генерирует современный макет под твою задачу — без Figma и дизайнера',
    'course.how.step3.title': 'ИИ верстает готовый код',
    'course.how.step3.note': 'Второй агент превращает макет в чистый рабочий сайт — автоматически',
    'course.how.step4.title': 'Ты проверяешь результат',
    'course.how.step4.note': 'Просматриваешь сайт, вносишь финальные правки если нужно',
    'course.how.step5.title': 'Сдаешь клиенту — получаешь оплату',
    'course.how.step5.note': 'Клиент получает готовый сайт, ты — деньги за работу',
    'course.testimonials.label': 'Отзывы студентов',
    'course.testimonials.r1.name': 'Марина',
    'course.testimonials.r1.role': 'Фрилансер, Киев',
    'course.testimonials.r1.text': 'Думала, что это сложно. За одну сессию сделала первый сайт — и уже нашла клиента. Ментор объяснял всё понятно, без воды.',
    'course.testimonials.r2.name': 'Алексей',
    'course.testimonials.r2.role': 'Малый бизнес, Варшава',
    'course.testimonials.r2.text': 'Хотел сам делать сайты для своего бизнеса. После сессии сделал сайт за вечер. Окупил курс сразу — сэкономил на разработчике.',
    'course.testimonials.r3.name': 'Дмитрий',
    'course.testimonials.r3.role': 'Без опыта в IT, Берлин',
    'course.testimonials.r3.text': 'Ноль опыта в программировании. После сессии понял как всё работает и уже делаю сайты на заказ. Стоит каждого цента.',
    // Sale Page
    'sale.timer.title': 'Специальное предложение заканчивается через:',
    'sale.timer.days': 'Дней',
    'sale.timer.hours': 'Часов',
    'sale.timer.minutes': 'Минут',
    'sale.timer.seconds': 'Секунд',
    'sale.hero.title': 'Сделаем индивидуальный сайт для вас',
    'sale.hero.titleHighlight': 'БЕСПЛАТНО',
    'sale.hero.subtitle': 'Платите только €15 в месяц за поддержку. Никаких скрытых платежей за разработку.',
    'sale.hero.bullet1': 'Бесплатная разработка сайта',
    'sale.hero.bullet2': 'Всего €15/мес за обслуживание',
    'sale.hero.bullet3': 'Отмена в любой момент',
    'sale.pricing.title': 'Стоимость создания сайта',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Получите готовый сайт бесплатно, оплачивая только небольшую подписку.',
    'sale.pricing.launch.title': 'Использование сайта',
    'sale.pricing.launch.price': '€15',
    'sale.pricing.launch.period': '/ мес',
    'sale.pricing.launch.desc': 'Всё необходимое для бесперебойной работы вашего сайта.',
    // SMS Page
    'sms.timer.title': 'Специальное предложение заканчивается через:',
    'sms.timer.days': 'Дней',
    'sms.timer.hours': 'Часов',
    'sms.timer.minutes': 'Минут',
    'sms.timer.seconds': 'Секунд',
    'sms.hero.title': 'Сделаем индивидуальный сайт для вас',
    'sms.hero.titleHighlight': 'БЕСПЛАТНО',
    'sms.hero.subtitle': 'Платите только 650 ₴ в месяц за поддержку. Никаких скрытых платежей за разработку.',
    'sms.hero.bullet1': 'Бесплатная разработка сайта',
    'sms.hero.bullet2': 'Всего 650 ₴/мес за обслуживание',
    'sms.hero.bullet3': 'Отмена в любой момент',
    'sms.pricing.title': 'Стоимость создания сайта',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Получите готовый сайт бесплатно, оплачивая только небольшую подписку.',
    'sms.pricing.launch.title': 'Использование сайта',
    'sms.pricing.launch.price': '650 ₴',
    'sms.pricing.launch.period': '/ мес',
    'sms.pricing.launch.desc': 'Всё необходимое для бесперебойной работы вашего сайта.',
    // About
    'about.team': 'Наша креативная команда',
    // Thank You Pages
    'thankyou.title': 'Спасибо!',
    'thankyou.desc': 'Ваша заявка получена. Мы свяжемся с вами в течение 24 часов с бесплатным макетом вашего сайта.',
    'thankyou.ref.title': 'Добро пожаловать в программу!',
    'thankyou.ref.desc': 'Ваша заявка на участие в реферальной программе получена.',
    'thankyou.ref.note': 'Мы свяжемся с вами в течение 24 часов и предоставим уникальную реферальную ссылку и все детали, необходимые для того, чтобы начать зарабатывать €100 за каждую рекомендацию.',
    'thankyou.ref.next': 'Что дальше?',
    'thankyou.ref.step1': 'Мы рассмотрим вашу заявку',
    'thankyou.ref.step2': 'Вы получите свою уникальную реферальную ссылку',
    'thankyou.ref.step3': 'Делитесь ссылкой и зарабатывайте €100 за каждую успешную рекомендацию',
    // Referral Page
    'ref.title': 'Реферальная',
    'ref.titleHighlight': 'программа',
    'ref.subtitle': 'Зарабатывайте €100 за каждую успешную рекомендацию',
    'ref.per': 'за успешную рекомендацию',
    'ref.how': 'Как это работает',
    'ref.how.1.title': 'Порекомендуйте нас',
    'ref.how.1.desc': 'Поделитесь Jetly Agency с друзьями, коллегами или знакомыми, которым нужен сайт.',
    'ref.how.2.title': 'Они получают демо',
    'ref.how.2.desc': 'Ваш контакт получает бесплатное демо сайта. Если он платит €299, вы зарабатываете.',
    'ref.how.3.title': 'Вы зарабатываете €100',
    'ref.how.3.desc': 'Получите €100 напрямую в течение 7 дней после успешной оплаты.',
    'ref.why': 'Почему стоит присоединиться?',
    'ref.why.1': '€100 за рекомендацию',
    'ref.why.2': 'Нет ограничений по заработку',
    'ref.why.3': 'Легко продавать (бесплатное демо)',
    'ref.why.4': 'Быстрые выплаты (7 дней)',
    'ref.form.title': 'Присоединиться к программе',
    'ref.form.desc': 'Заполните форму ниже, и мы свяжемся с вами и предоставим уникальную реферальную ссылку.',
    'ref.form.name': 'Ваше имя *',
    'ref.form.namePlaceholder': 'Иван Иванов',
    'ref.form.email': 'Email адрес *',
    'ref.form.emailPlaceholder': 'ivan@example.com',
    'ref.form.phone': 'Телефон *',
    'ref.form.phonePlaceholder': '+7 900 000 00 00',
    'ref.form.message': 'Расскажите о вашей сети контактов',
    'ref.form.messagePlaceholder': 'Кого вы планируете рекомендовать? (например, владельцев малого бизнеса, предпринимателей и т.д.)',
    'ref.form.submit': 'Присоединиться',
    'ref.form.submitting': 'Отправка...'
  },
  ua: {
    // Navigation
    'nav.getStarted': 'Безкоштовна консультація',
    'nav.home': 'Головна',
    'nav.services': 'Ціни',
    'nav.howItWorks': 'Як це працює',
    'nav.referral': 'Реферальна програма',
    'nav.privacy': 'Політика конфіденційності',
    'nav.terms': 'Умови використання',
    'nav.pricing': 'Ціни',
    'nav.faq': 'Питання',
    'nav.testimonials': 'Відгуки',
    // Cookie Banner
    'cookie.title': 'Ми використовуємо cookies',
    'cookie.description': 'Ми використовуємо cookies для покращення вашого досвіду на сайті, аналізу трафіку та персоналізації контенту.',
    'cookie.accept': 'Прийняти все',
    'cookie.decline': 'Відхилити',
    'cookie.learnMore': 'Детальніше',
    // Hero - H1
    'hero.badge': 'Професійне веб-агентство',
    'hero.title': 'Зробимо індивідуальний сайт для вас',
    'hero.titleHighlight': 'всього за €299',
    'hero.subtitle': 'Покажемо безкоштовний макет вашого сайту. Якщо не сподобається — ви нічого не платите.',
    'hero.bullet1': "Безкоштовне прев'ю сайту до оплати",
    'hero.bullet2': '€299 — вартість розробки сайту, якщо вам усе підходить',
    'hero.bullet3': 'Працюємо онлайн по всьому світу',
    'hero.cta': 'Безкоштовна консультація',
    'hero.referral': 'Реферальна програма',
    // Pricing - H2: Ціни та умови
    'pricing.title': 'Ціни',
    'pricing.titleHighlight': 'та умови',
    'pricing.subtitle': 'Спочатку безкоштовний макет. Оплата тільки якщо вам усе підходить.',
    // H3: Безкоштовне демо сайту
    'pricing.demo.title': 'Безкоштовний макет сайту',
    'pricing.demo.label': 'БЕЗКОШТОВНО',
    'pricing.demo.desc': 'Покажемо ваш майбутній сайт до оплати.',
    'pricing.demo.b1': 'Макет під ваш бізнес',
    'pricing.demo.b2': 'Можна попросити правки',
    'pricing.demo.b3': 'Якщо не сподобається — не платите',
    'pricing.demo.cta': 'Безкоштовна консультація',
    // H3: Розробка сайту — €299 (разово)
    'pricing.launch.title': 'Розробка сайту',
    'pricing.launch.price': '€299',
    'pricing.launch.period': '(разово)',
    'pricing.launch.desc': 'Якщо вам усе підходить — ви отримуєте готовий сайт.',
    'pricing.launch.b1': 'Індивідуальний дизайн',
    'pricing.launch.b2': 'Адаптація під телефон',
    'pricing.launch.b3': 'Правки за запитом',
    'pricing.launch.b4': 'Форма заявок',
    'pricing.launch.cta': 'Безкоштовна консультація',
    // How It Works - H2: Як це працює
    'how.title': 'Як це',
    'how.titleHighlight': 'працює',
    // H3 steps
    'how.step1.title': 'Розкажіть про ваш бізнес',
    'how.step1.note': 'Займе 2 хвилини — чим займаєтесь і який сайт потрібен',
    'how.step2.title': 'Ми робимо безкоштовне демо сайту',
    'how.step2.note': 'Покажемо дизайн і структуру. Надішлемо посилання за 1–3 дні',
    'how.step3.title': 'Ви кажете, що змінити',
    'how.step3.note': 'Текст, блоки, стиль — ми все підправляємо під вас',
    'how.step4.title': 'Якщо все підходить — ви сплачуєте €299',
    'how.step4.note': 'Оплата тільки після того, як ви скажете: "Так, мені підходить"',
    'how.step5.title': 'Підключаємо домен і публікуємо сайт',
    'how.step5.note': 'Сайт починає працювати та приймати заявки',
    'how.note': 'Якщо сайт вам не сподобається — ви не платите.',
    // FAQ - H2: Поширені запитання
    'faq.title': 'Поширені',
    'faq.titleHighlight': 'запитання',
    'faq.subtitle': 'Все, що потрібно знати про роботу з нами',
    // H3 questions
    'faq.q1': 'Що таке безкоштовний макет?',
    'faq.a1': 'Це попередній варіант вашого сайту до оплати.',
    'faq.q2': 'Коли я сплачую €299?',
    'faq.a2': 'Тільки якщо макет вам підходить і ви хочете запускати сайт.',
    'faq.q3': 'Чи можна попросити правки?',
    'faq.a3': 'Так, ми можемо внести зміни перед запуском.',
    'faq.q4': 'Що я отримаю після оплати?',
    'faq.a4': 'Готовий сайт для вашого бізнесу.',
    'faq.q5': 'Ви працюєте по всьому світу?',
    'faq.a5': 'Так, працюємо онлайн з клієнтами з різних країн.',
    // Testimonials - H2: Відгуки клієнтів
    'testimonials.title': 'Відгуки',
    'testimonials.titleHighlight': 'клієнтів',
    'testimonials.subtitle': 'Що кажуть клієнти про роботу з нами',
    'testimonials.r1.name': 'Оксана',
    'testimonials.r1.text': 'Сподобалося, що спочатку мені показали сайт безкоштовно. Я попросила пару правок, все швидко виправили. Оплатила тільки коли все влаштувало.',
    'testimonials.r1.business': 'Майстер манікюру',
    'testimonials.r2.name': 'Віталій',
    'testimonials.r2.text': 'Мені зробили зрозумілий сайт під мої послуги. Спочатку показали макет, потім внесли правки. Оплатив тільки після підтвердження.',
    'testimonials.r2.business': 'Ремонт техніки',
    'testimonials.r3.name': 'Андрій',
    'testimonials.r3.text': 'Зручно, що не потрібно платити заздалегідь. Спочатку подивився сайт, попросив спростити текст, після цього оплатив. Все чесно і зрозуміло.',
    'testimonials.r3.business': 'Юрист',
    // Consultation - H2: Отримати безкоштовне демо
    'consultation.title': 'Замовити безкоштовну',
    'consultation.titleHighlight': 'консультацію',
    'consultation.subtitle': "Скажіть, що вам потрібно — ми надішлемо посилання на прев'ю.",
    'consultation.benefit1': 'Безкоштовний перегляд',
    'consultation.benefit2': 'Швидка доставка',
    'consultation.benefit3': "Без зобов'язань",
    'consultation.name': "Ім'я",
    'consultation.namePlaceholder': "Ваше ім'я",
    'consultation.email': 'Email',
    'consultation.emailPlaceholder': 'ваш@email.com',
    'consultation.desc': 'Опис проєкту',
    'consultation.descPlaceholder': 'Розкажіть про ваш бізнес і який сайт вам потрібен...',
    'consultation.cta': 'Замовити безкоштовну консультацію',
    'consultation.note': "Без зобов'язань. Якщо сайт не сподобається — ви не платите.",
    'consultation.sending': 'Відправка...',
    'consultation.or': 'або напишіть нам напряму',
    'consultation.telegram': 'Telegram',
    'consultation.whatsapp': 'WhatsApp',
    // Footer
    'footer.services': 'Послуги',
    'footer.company': 'Компанія',
    'footer.legal': 'Юридичне',
    'footer.contact': 'Контакти',
    'footer.rights': 'Всі права захищені.',
    'footer.aboutLink': 'Про нас',
    // Stats
    'stats.websites': 'Сайтів запущено',
    'stats.clients': 'Задоволених клієнтів',
    'stats.years': 'Років досвіду',
    'stats.title': 'Наш',
    'stats.titleHighlight': 'Вплив',
    'stats.subtitle': 'Результати для бізнесу по всьому світу',
    // AI Course Page
    'course.hero.badge': 'Стань власником digital-бізнесу',
    'course.hero.title': 'Купити готовий IT-бізнес під ключ: власна веб-студія на базі ШІ',
    'course.hero.pill1': 'Без досвіду',
    'course.hero.pill2': 'Швидко окупається',
    'course.hero.pill3': 'Працюй на себе',
    'course.hero.socialProof': 'вже заробляють з ШІ',
    'course.hero.socialProofCount': '100+ студентів',
    'course.hero.specialPrice': 'Вартість',
    'course.hero.buyCourse': 'Купити бізнес',
    'course.recognize.title': 'Впізнаєш себе?',
    'course.recognize.c1.title': 'Працюєш на когось — а міг би на себе',
    'course.recognize.c1.text': 'Кожен день віддаєш свій час і сили чужому бізнесу. А свій — все ніяк не почати.',
    'course.recognize.c2.title': 'Хочеш більше грошей — але не знаєш як',
    'course.recognize.c2.text': 'Зарплата не росте. Фріланс лякає. Здається, що для заробітку в інтернеті потрібні особливі знання.',
    'course.recognize.c3.title': 'Думаєш що IT — це не для тебе',
    'course.recognize.c3.text': 'Код, розробка, технології — звучить складно. Здається, що це тільки для тих, хто вчився роками.',
    'course.recognize.c4.title': 'Бачиш як інші заробляють — і втрачаєш час',
    'course.recognize.c4.text': 'ШІ вже змінив ринок. Ті, хто зайшов раніше — вже заробляють. Ти все ще думаєш.',
    'course.offer.title': 'Що ми пропонуємо?',
    'course.offer.tag1': 'Готовий бізнес',
    'course.offer.tag2': 'Підходить навіть для новачків',
    'course.offer.heading': 'Купить it бизнес под ключ',
    'course.offer.description': 'Система, яка створює сайти замість тебе. Ти описуєш задачу — ШІ сам прототипує структуру, малює дизайн і верстає готовий код.',
    'course.offer.tagline1': 'Один актив, який відкриває нове джерело доходу.',
    'course.offer.tagline2': 'Без досвіду, без коду — просто ти і ШІ.',
    'course.offer.feature1': 'Сайт IT агенції',
    'course.offer.feature2': 'ШІ-агент прототипування та дизайну',
    'course.offer.feature3': 'ШІ-агент верстки і написання коду',
    'course.offer.feature4': 'Покроковий гайд по роботі з системою',
    'course.offer.feature5': 'Довічна технічна підтримка',
    'course.offer.price': '€9 500',
    'course.offer.priceLabel': '',
    'course.offer.priceDescription': 'Все, що потрібно, щоб почати створювати і продавати сайти.',
    'course.offer.cta': 'Купити бізнес',
    'course.calc.title': 'Скільки можна заробити на створенні сайтів за допомогою ШІ?',
    'course.calc.priceLabel': 'За скільки ти готовий продати сайт?',
    'course.calc.sitesLabel': 'Скільки сайтів на місяць ти хочеш робити?',
    'course.calc.potentialIncome': 'ТВІЙ ПОТЕНЦІЙНИЙ ДОХІД',
    'course.calc.perMonth': '/ міс',
    'course.calc.coursePrice': 'Вартість бізнесу',
    'course.calc.payback': 'Окупність',
    'course.calc.paybackValue': '',
    'course.calc.netProfit': 'Чистий прибуток (1-й міс)',
    'course.faq.title': 'Часті питання',
    'course.faq.subtitle': 'Все, що потрібно знати про готовий бізнес',
    'course.faq.q1': 'Чи потрібен досвід в IT або розробці?',
    'course.faq.a1': 'Ні. Система повністю автоматизована — ти описуєш задачу, ШІ робить дизайн і код. Жодного програмування, жодного Figma.',
    'course.faq.q2': 'Що конкретно я отримую після покупки?',
    'course.faq.a2': 'Готовий сайт агентства, два ШІ-агенти для створення дизайну і верстки коду, покроковий гайд по роботі з системою та довічну технічну підтримку.',
    'course.faq.q3': 'Скільки часу займає створення одного сайту?',
    'course.faq.a3': 'Від 30 хвилин до кількох годин залежно від складності. Більшу частину роботи виконує ШІ — тобі залишається тільки перевірити результат.',
    'course.faq.q4': 'Чи можна побачити як працює система до покупки?',
    'course.faq.a4': 'Так. Запишися на безкоштовну консультацію — ми покажемо демо і відповімо на всі питання.',
    'course.faq.q5': 'За скільки я можу продавати сайти клієнтам?',
    'course.faq.a5': 'Це повністю твоє рішення. Середня ринкова вартість односторінкового сайту — €450. Ніяких обмежень з нашого боку немає.',
    'course.faq.q6': 'Що якщо виникнуть технічні проблеми?',
    'course.faq.a6': 'Ми надаємо довічну технічну підтримку. Напишеш нам — допоможемо розібратися з будь-яким питанням.',
    'course.faq.q7': 'Чи можна масштабувати цей бізнес?',
    'course.faq.a7': 'Так. Система не має обмежень по кількості сайтів. Чим більше замовлень — тим більший дохід. Наймати команду не потрібно.',
    'course.fear.title1': 'Поки ти сумніваєшся — ',
    'course.fear.title2': 'хтось вже відкрив свій digital-бізнес.',
    'course.fear.f1.fear': '«Я ніколи не робив сайти»',
    'course.fear.f1.reality': 'Просто опиши що хочеш — ШІ зробить все сам',
    'course.fear.f2.fear': '«Це складно і довго»',
    'course.fear.f2.reality': 'Ти створиш перший сайт прямо після першого заняття',
    'course.fear.f3.fear': '«Не знаю де брати клієнтів»',
    'course.fear.f3.reality': 'Кожен ресторан, салон, лікар, магазин — твій потенційний клієнт',
    'course.fear.f4.fear': '«А раптом не вийде»',
    'course.fear.f4.reality': 'Ментор поруч — не кинемо поки не вийде',
    'course.cta.title': 'Готові почати бізнес?',
    'course.cta.subtitle': 'Один актив. Необмежена кількість сайтів.',
    'course.cta.btn': 'Купити бізнес — €9 500',
    'course.cta.link': 'або записатися на безкоштовну консультацію →',
    'course.how.title': 'Як це',
    'course.how.titleHighlight': 'працює',
    'course.how.step1.title': 'Ти описуєш задачу',
    'course.how.step1.note': 'Вказуєш нішу, стиль і що має робити сайт — більше нічого не потрібно',
    'course.how.step2.title': 'ШІ створює дизайн',
    'course.how.step2.note': 'Агент генерує сучасний макет під твою задачу — без Figma і дизайнера',
    'course.how.step3.title': 'ШІ верстає готовий код',
    'course.how.step3.note': 'Другий агент перетворює макет у чистий робочий сайт — автоматично',
    'course.how.step4.title': 'Ти перевіряєш результат',
    'course.how.step4.note': 'Переглядаєш сайт, вносиш фінальні правки якщо потрібно',
    'course.how.step5.title': 'Здаєш клієнту — отримуєш оплату',
    'course.how.step5.note': 'Клієнт отримує готовий сайт, ти — гроші за роботу',
    'course.testimonials.label': 'Відгуки студентів',
    'course.testimonials.r1.name': 'Марина',
    'course.testimonials.r1.role': 'Фрілансер, Київ',
    'course.testimonials.r1.text': 'Думала, що це складно. За одну сесію зробила перший сайт — і вже знайшла клієнта. Ментор пояснював все зрозуміло, без води.',
    'course.testimonials.r2.name': 'Олексій',
    'course.testimonials.r2.role': 'Малий бізнес, Варшава',
    'course.testimonials.r2.text': 'Хотів сам робити сайти для свого бізнесу. Після сесії зробив сайт за вечір. Окупив курс відразу — заощадив на розробнику.',
    'course.testimonials.r3.name': 'Дмитро',
    'course.testimonials.r3.role': 'Без досвіду в IT, Берлин',
    'course.testimonials.r3.text': 'Нуль досвіду в програмуванні. Після сесії зрозумів як все працює і вже роблю сайти на замовлення. Вартує кожного цента.',
    // Sale Page
    'sale.timer.title': 'Спеціальна пропозиція закінчується через:',
    'sale.timer.days': 'Днів',
    'sale.timer.hours': 'Годин',
    'sale.timer.minutes': 'Хвилин',
    'sale.timer.seconds': 'Секунд',
    'sale.hero.title': 'Зробимо індивідуальний сайт для вас',
    'sale.hero.titleHighlight': 'БЕЗКОШТОВНО',
    'sale.hero.subtitle': 'Платіть лише €15 на місяць за підтримку. Жодних прихованих платежів за розробку.',
    'sale.hero.bullet1': 'Безкоштовна розробка сайту',
    'sale.hero.bullet2': 'Всього €15/міс за обслуговування',
    'sale.hero.bullet3': 'Скасування в будь-який момент',
    'sale.pricing.title': 'Вартість створення сайту',
    'sale.pricing.titleHighlight': ' ',
    'sale.pricing.subtitle': 'Отримайте готовий сайт безкоштовно, сплачуючи лише невелику підписку.',
    'sale.pricing.launch.title': 'Використання сайту',
    'sale.pricing.launch.price': '€15',
    'sale.pricing.launch.period': '/ міс',
    'sale.pricing.launch.desc': 'Все необхідне для безперебійної роботи вашого сайту.',
    // SMS Page
    'sms.timer.title': 'Спеціальна пропозиція закінчується через:',
    'sms.timer.days': 'Днів',
    'sms.timer.hours': 'Годин',
    'sms.timer.minutes': 'Хвилин',
    'sms.timer.seconds': 'Секунд',
    'sms.hero.title': 'Зробимо індивідуальний сайт для вас',
    'sms.hero.titleHighlight': 'БЕЗКОШТОВНО',
    'sms.hero.subtitle': 'Платіть лише 650 ₴ на місяць за підтримку. Жодних прихованих платежів за розробку.',
    'sms.hero.bullet1': 'Безкоштовна розробка сайту',
    'sms.hero.bullet2': 'Всього 650 ₴/міс за обслуговування',
    'sms.hero.bullet3': 'Скасування в будь-який момент',
    'sms.pricing.title': 'Вартість створення сайту',
    'sms.pricing.titleHighlight': ' ',
    'sms.pricing.subtitle': 'Отримайте готовий сайт безкоштовно, сплачуючи лише невелику підписку.',
    'sms.pricing.launch.title': 'Використання сайту',
    'sms.pricing.launch.price': '650 ₴',
    'sms.pricing.launch.period': '/ міс',
    'sms.pricing.launch.desc': 'Все необхідне для безперебійної роботи вашого сайту.',
    // About
    'about.team': 'Наша креативна команда',
    // Thank You Pages
    'thankyou.title': 'Дякуємо!',
    'thankyou.desc': "Вашу заявку отримано. Ми зв'яжемося з вами протягом 24 годин з безкоштовним макетом вашого сайту.",
    'thankyou.ref.title': 'Ласкаво просимо до програми!',
    'thankyou.ref.desc': 'Вашу заявку на участь у реферальній програмі отримано.',
    'thankyou.ref.note': "Ми зв'яжемося з вами протягом 24 годин і надамо унікальне реферальне посилання та всі деталі, необхідні для того, щоб почати заробляти €100 за кожну рекомендацію.",
    'thankyou.ref.next': 'Що далі?',
    'thankyou.ref.step1': 'Ми розглянемо вашу заявку',
    'thankyou.ref.step2': 'Ви отримаєте своє унікальне реферальне посилання',
    'thankyou.ref.step3': 'Діліться посиланням і заробляйте €100 за кожну успішну рекомендацію',
    // Referral Page
    'ref.title': 'Реферальна',
    'ref.titleHighlight': 'програма',
    'ref.subtitle': 'Заробляйте €100 за кожну успішну рекомендацію',
    'ref.per': 'за успішну рекомендацію',
    'ref.how': 'Як це працює',
    'ref.how.1.title': 'Порекомендуйте нас',
    'ref.how.1.desc': 'Поділіться Jetly Agency з друзями, колегами або знайомими, яким потрібен сайт.',
    'ref.how.2.title': 'Вони отримують демо',
    'ref.how.2.desc': 'Ваш контакт отримує безкоштовне демо сайту. Якщо він платить €299, ви заробляєте.',
    'ref.how.3.title': 'Ви заробляєте €100',
    'ref.how.3.desc': 'Отримайте €100 безпосередньо протягом 7 днів після успішної оплати.',
    'ref.why': 'Чому варто приєднатися?',
    'ref.why.1': '€100 за рекомендацію',
    'ref.why.2': 'Немає обмежень щодо заробітку',
    'ref.why.3': 'Легко продавати (безкоштовне демо)',
    'ref.why.4': 'Швидкі виплати (7 днів)',
    'ref.form.title': 'Приєднатися до програми',
    'ref.form.desc': "Заповніть форму нижче, і ми зв'яжемося з вами та надамо унікальне реферальне посилання.",
    'ref.form.name': "Ваше ім'я *",
    'ref.form.namePlaceholder': 'Іван Іванов',
    'ref.form.email': 'Email адреса *',
    'ref.form.emailPlaceholder': 'ivan@example.com',
    'ref.form.phone': 'Телефон *',
    'ref.form.phonePlaceholder': '+380 00 000 00 00',
    'ref.form.message': 'Розкажіть про вашу мережу контактів',
    'ref.form.messagePlaceholder': 'Кого ви плануєте рекомендувати? (наприклад, власників малого бізнесу, підприємців тощо)',
    'ref.form.submit': 'Приєднатися',
    'ref.form.submitting': 'Відправлення...'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('sk');
  useEffect(() => {
    const updateLanguageFromPath = () => {
      const path = window.location.pathname;
      if (path.startsWith('/ru')) {
        setLanguage('ru');
      } else if (path.startsWith('/ua') || path.startsWith('/uk')) {
        setLanguage('ua');
      } else if (path.startsWith('/en')) {
        setLanguage('en');
      } else {
        setLanguage('sk');
      }
    };
    // Initial check
    updateLanguageFromPath();
    // Listen for client-side navigation
    window.addEventListener('popstate', updateLanguageFromPath);
    return () => window.removeEventListener('popstate', updateLanguageFromPath);
  }, []);
  const t = (key: string): string => {
    return translations[language][key as keyof (typeof translations)['en']] || key;
  };
  const getPath = (path: string): string => {
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    if (language === 'ru') {
      return `/ru/${cleanPath}`;
    } else if (language === 'ua') {
      return `/ua/${cleanPath}`;
    } else if (language === 'en') {
      return `/en/${cleanPath}`;
    }
    return `/${cleanPath}`;
  };
  const navigate = (path: string) => {
    // If it's just a hash link on the same page
    if (path.startsWith('#')) {
      const element = document.querySelector(path);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    // Otherwise, it's a page navigation
    const fullPath = getPath(path);
    // Check if we are navigating to a hash on a different page
    const [pagePath, hash] = fullPath.split('#');
    window.history.pushState({}, '', pagePath);
    window.dispatchEvent(new Event('popstate'));
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    getPath,
    navigate
  }} data-id="element-533">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}